export const styles = {
  icon: {
    color: "text.primary",
  },
  iconSelected: {
    color: "primary.light",
  },
}
